"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateField = void 0;
const react_1 = __importDefault(require("react"));
const DateField = ({ field, value, onChange, error, disabled }) => {
    const minDate = field.validation?.minDate;
    const maxDate = field.validation?.maxDate;
    const toIsoDate = (dateStr) => {
        if (!dateStr)
            return undefined;
        if (dateStr.includes('-') && dateStr.indexOf('-') === 4)
            return dateStr;
        const parts = dateStr.split('/');
        if (parts.length === 3)
            return `${parts[2]}-${parts[1]}-${parts[0]}`;
        return undefined;
    };
    return (react_1.default.createElement("div", { className: "field-group" },
        react_1.default.createElement("label", { className: "field-label" },
            field.label,
            field.required && react_1.default.createElement("span", { className: "required" }, "*")),
        field.tooltip && react_1.default.createElement("span", { className: "field-hint" }, field.tooltip),
        react_1.default.createElement("input", { type: "date", className: `field-input${error ? ' error' : ''}`, name: field.key, value: value || '', onChange: (e) => onChange(field.key, e.target.value), min: toIsoDate(minDate), max: toIsoDate(maxDate), disabled: disabled }),
        error && react_1.default.createElement("div", { className: "field-error" }, error)));
};
exports.DateField = DateField;
